import { adminGet } from "@lib/adminApi";
import type { Entitlement } from "@pages/ProductCatalog/store";

// omg-api admin entitlement catalog (OMG-2091), replacing the legacy GraphQL
// listEntitlements. Each entitlement carries the product ids it grants.
export interface AdminEntitlement {
  id: number;
  name: string;
  productIds: number[];
}

export const listAdminEntitlements = (): Promise<AdminEntitlement[]> =>
  adminGet<AdminEntitlement[]>("/admin/entitlements");

// The user + catalog pages model entitlements as { id, name }; the product
// links aren't used by the UI, so drop them here.
export const listEntitlements = async (): Promise<Entitlement[]> => {
  const entitlements = await listAdminEntitlements();
  return entitlements.map(({ id, name }) => ({ id, name }));
};
